import { environmentConfig } from "@src/appV2/environment";
import request from "superagent";

import { getAuthHeader } from "../superagent";

const retryOnceParams = [1, (err: Error) => !!err] as const;

export async function resyncAccountWithStripe(agentId: string): Promise<void> {
  await request
    .post(`${environmentConfig.REACT_APP_PAYMENTS_API_URL}/accounts/${agentId}/resync-from-stripe`)
    .retry(...retryOnceParams)
    .set(await getAuthHeader())
    .then(({ body }) => body)
    .catch((err) => {
      console.error(err);
    });
}
